module.exports = require("child-process-promise");


//////////////////
// WEBPACK FOOTER
// external "child-process-promise"
// module id = 92
// module chunks = 0 1 2 3 4 5 6 7